/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseEffectiveResourceAccess } from '../models/api-response-effective-resource-access';
import { getEffectiveAccess } from '../fn/effective-access-api/get-effective-access';
import { GetEffectiveAccess$Params } from '../fn/effective-access-api/get-effective-access';

@Injectable({ providedIn: 'root' })
export class EffectiveAccessApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getEffectiveAccess()` */
  static readonly GetEffectiveAccessPath = '/v1/api/ui/access/effective/{resourceType}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEffectiveAccess()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEffectiveAccess$Response(params: GetEffectiveAccess$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseEffectiveResourceAccess>> {
    return getEffectiveAccess(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEffectiveAccess$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEffectiveAccess(params: GetEffectiveAccess$Params, context?: HttpContext): Observable<ApiResponseEffectiveResourceAccess> {
    return this.getEffectiveAccess$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseEffectiveResourceAccess>): ApiResponseEffectiveResourceAccess => r.body)
    );
  }

}
